import { Component, inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SharedApplicantService } from '../../shared/services/shared-applicant.service';
import { ToastrService } from 'ngx-toastr';
import { EgTableComponent } from '../../shared/components/eg-table/eg-table.component';
import { ApplicantService } from '../../service/applicant.service';
import { MatDialog } from '@angular/material/dialog';
import { ApplicantDetailDialogComponent } from './applicant-detail-dialog/applicant-detail-dialog.component';
import { SharedCaseManagementService } from '../../shared/services/shared-case-management.service';
import { forkJoin } from 'rxjs';
import { UserManagementService } from '../../service/user-management.service';
import { UserService } from '../../shared/services/user.service';

@Component({
  selector: 'app-applicant-detail',
  standalone: true,
  imports: [CommonModule, EgTableComponent],
  templateUrl: './applicant-detail.component.html',
  styleUrls: ['./applicant-detail.component.scss'],
})
export class ApplicantDetailComponent implements OnInit {
  applications: any;
  applicant: any;
  isLoading: boolean = true;
  error: string | null = null;
  firstName: string | null = null;
  lastName: string | null = null;
  clientNumber: number | null = null;
  birthday: string | null = null;
  locationAddress: string | null = null;
  MailingAddress: string | null = null;
  emailAddress: string | null = null;
  phoneNo: string | null = null;
  applicantId: string | null = null;
  submittedByName: string = '';
  submittedByDate: string = '';
  submittedApplicationId: any;
  applicationsCopy: any;
  start = 0;
  end = 10;
  pageSize = 10;
  pageIndex = 0;
  totalElements = 0;
  cols: any = [];
  displayedColumns: { key: string; label: string }[] = [];
  isEligibilityAutoDetermined: boolean = false;
  constructor(
    private readonly route: ActivatedRoute,
    private readonly http: HttpClient,
    private readonly router: Router,
    private readonly sharedApplicantService: SharedApplicantService,
    private readonly toastr: ToastrService,
    private readonly applicantService: ApplicantService,
    private readonly sharedCaseManagementService: SharedCaseManagementService,
    private readonly userManagementService: UserManagementService,
    private readonly userService: UserService,
  ) {}

  ngOnInit() {
      
    // isEligibilityAutoDetermined : true => Meck
    // isEligibilityAutoDetermined : false => Rock

    this.isEligibilityAutoDetermined = sessionStorage.getItem('isEligibilityAutoDetermined') === 'true';
    if(this.isEligibilityAutoDetermined) {
      this.cols = ['applicationId','updatedDate','completionStatus','caseManager','actionsApplications'];
      this.displayedColumns = [
        {
          key: 'applicationId',
          label: 'Application ID',
        },
        {
          key: 'updatedDate',
          label: 'Updated Date',
        },
        {
          key: 'completionStatus',
          label: 'Completion Status',
        },
        {
          key: 'caseManager',
          label: 'Case Manager',
        },
        {
          key: 'actionsApplications',
          label: 'Actions',
        }
      ];
    }
    else {
      this.cols = ['applicationId','updatedDate','caseCompletionStatus','caseManager','applicationType','actionsApplications', 'renewal'];
      this.displayedColumns = [
        {
          key: 'applicationId',
          label: 'Application ID',
        },
        {
          key: 'updatedDate',
          label: 'Updated Date',
        },
        {
          key: 'caseCompletionStatus',
          label: 'Case Status',
        },
        {
          key: 'caseManager',
          label: 'Case Manager',
        },
        {
          key: 'applicationType',
          label: 'Type',
        },
        {
          key: 'actionsApplications',
          label: 'Actions',
        },
        {
          key: 'renewal',
          label: 'Renewal',
        }
      ];
    }
    console.log(this.cols);
    
    if (!this.applicantId) {
      this.applicantId = this.sharedApplicantService.getApplicantId() || localStorage.getItem('applicantId');
    }
    if (this.applicantId) {
      this.isLoading = true;
      forkJoin({
        applicant: this.applicantService.fetchApplicantDetails(Number(this.applicantId)),
        applications: this.applicantService.fetchApplications(this.applicantId, String(this.start), String(this.pageSize))
      }).subscribe({
        next: ({ applicant, applications }: { applicant: any; applications: any }) => {
          if(applicant) {
            this.applicant = applicant;
            localStorage.setItem('applicantId', this.applicantId ?? '');
            // Applicant details mapping
            this.mapApplicantDetails(applicant.applicantDetailsAsJson);
          }
          else {
            this.toastr.error('Error fetching applicant details. Please try again.');
          }
          if(applications) {
            // Applications mapping
            this.mapApplications(applications);
          }
          this.isLoading = false;
        },
        error: (error: any) => {
          console.error('Error fetching applicant or applications:', error);
          this.toastr.error('Error fetching applicant or applications. Please try again.');
          this.isLoading = false;
          this.userManagementService.redirectToLogin(error, '');
        }
      });
    }
  }

  downloadDeterminationLetter(applicationId: number) {
    const applicantId: number = Number(this.applicantId);
    this.applicantService.downloadDeterminationLetter(applicantId, applicationId).subscribe({
      next: (response: Blob) => {
        // Creating a temporary link to trigger the download
        const fileURL = window.URL.createObjectURL(response);
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = applicationId + '-TAF Letter.docx';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(fileURL);
        this.toastr.success(`Determination letter download started ...`, '', {
          timeOut: 1000,
        });
      },
      error: (error) => {
        console.error('Error fetching determination letter:', error);
        this.error =
          'Could not fetch determination letter. Please try again later.';
        this.toastr.error(this.error, '', { timeOut: 1000 });
        this.userManagementService.redirectToLogin(error,'');
      }
    }
    );
  }

  goToApplicationForm() {
    if(this.applicant?.applicantId) {
      this.sharedApplicantService.changeApplicantId(this.applicant.applicantId);
      this.router.navigate(['/application-form']);
    }
  }
  private mapApplicantDetails(applicantDetails: any) {
    this.firstName = applicantDetails.first_name;
    this.lastName = applicantDetails.last_name;
    this.clientNumber = applicantDetails.extra2;
    this.birthday = applicantDetails.date_of_birth;
    this.emailAddress = applicantDetails.email;

    const addressParts = [
      applicantDetails?.home_street_number,
      applicantDetails?.home_street,
      applicantDetails?.home_city,
      applicantDetails?.home_state,
      applicantDetails?.home_postcode
    ].filter(part => part && part.trim() !== '');
    this.locationAddress = addressParts.join(', ');
    this.MailingAddress = this.locationAddress;

    let phoneRaw = this.isEligibilityAutoDetermined ? applicantDetails?.extra7 : applicantDetails?.phone_landline;
    if (!phoneRaw) {
      this.phoneNo = '';
    } else if (!phoneRaw.includes('-')) {
      this.phoneNo = [phoneRaw.slice(0, 3), "-", phoneRaw.slice(3, 6), "-", phoneRaw.slice(6)].join('');
    } else {
      this.phoneNo = phoneRaw;
    }
  }
  private mapApplications(applications: any) {
    this.applications = applications;
    this.applicationsCopy = applications?.content?.map((application: any) => {
      let workflowStatusValue = '';
      let caseCompletionStatus: string = '';
      let renewalRemainingDays = 0;
      if (application?.completionStatus) {
        if (application?.completionStatus == '2' || application?.completionStatus == '3') {
          caseCompletionStatus = 'Terminated';
        } else {
          caseCompletionStatus = application.caseStatus;
        }
      }
      if (application?.workflowStatus) {
        workflowStatusValue = application.workflowStatus;
      } else if (application?.caseStatus) {
        workflowStatusValue = application.caseStatus;
      }
      if(application?.renewalRemainingDays) {
        renewalRemainingDays = application?.renewalRemainingDays.split(' ')[0];
      }
      return {
        applicationId: application.applicationId,
        updatedDate: application.updatedDate,
        completionStatus: application.completionStatus,
        caseManager: application.user ? `${application.user.firstName} ${application.user.lastName}` : 'Unknown',
        historical: application.historical,
        actionsApplications: '',
        workflowStatusId: application.workflowStatusId,
        workflowStatus: workflowStatusValue,
        caseCompletionStatus: caseCompletionStatus,
        submittedBy: application.user ? `${application.user.firstName} ${application.user.lastName}` : 'Unknown',
        applicationType: application?.applicationType ? application.applicationType : 'Application',
        renewal: application?.showRenewalButton ? renewalRemainingDays : 0,
        highlightPrintRenewalLetter: application?.highlightPrintRenewalLetter || false,
        renewalLetterPrinted: application?.renewalLetterPrinted || false,
        parentApplicationId: application?.parentApplicationId,
        caseCompletionGroupStatus: application?.caseCompletionGroupStatus || '',
        caseStatusGroup: application?.caseStatusGroup || '',
      };
    }) || [];
    console.log(this.applicationsCopy[0]);
    console.log(this.applicationsCopy[1]);
    
    /*
            completionStatus : In Progress = 0;
            completionStatus : Submitted = 1;
            completionStatus : Terminated = 2;
            completionStatus : Terminated (Manually) = 3; 
      */
      if(this.applicationsCopy && this.applicationsCopy?.length > 0) {
      this.applicationsCopy?.forEach((application: any) => {
        if(application?.completionStatus == 1) {
          let date = new Date(application?.updatedDate);
          date.setFullYear(date.getFullYear() + 1);
          let newDate = date?.toISOString();
          if(newDate < new Date().toISOString()) {
            application.completionStatus = 2;
          }
        }
      });
      }
    this.end = applications?.numberOfElements || 0;
    this.totalElements = applications?.totalElements || 0;
    this.applications?.content.forEach((application: any) => {
      const user = application.user;
      if (user) {
        application.submittedBy = `${user.firstName} ${user.lastName}`;
      } else {
        application.submittedBy = 'Unknown'; // Handle cases where user might not exist
      }
    });
    this.isLoading = false;
  }
  fetchApplicantDetails(applicantId: any) {
    this.applicantService.fetchApplicantDetails(applicantId).subscribe({
      next: (response: any) => {
        this.applicant = response;
        this.applicantId = applicantId;
        localStorage.setItem('applicantId', applicantId);
        this.mapApplicantDetails(this.applicant.applicantDetailsAsJson);
        this.isLoading = false;
      },
      error: (error) => {
        console.error('There was an error fetching applicant details:', error);
        this.toastr.error('There was an error fetching applicant details. Please try again.');
        this.userManagementService.redirectToLogin(error,'');
        this.isLoading = false;
      }
    }
    );
  }
  fetchApplications(applicantId: string,start: any, limit: any) {
    this.isLoading = true;
    this.applicantService.fetchApplications(applicantId, start, limit).subscribe({
      next: (response: any) => {
        this.mapApplications(response);
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
        console.error('There was an error fetching applications:', error);
        this.toastr.error('There was an error fetching applications. Please try again.');
      }
    }
    );
  }
  getChangedApplicationsList(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.fetchApplications(this.applicant.applicantId, this.pageIndex, this.pageSize);
  }
  getCompletionStatus(event: any) {
    if(event?.downloadStatus == 'download') {
      this.downloadDeterminationLetter(event?.applicationId);
    }
    else if(event?.terminateStatus == 'terminate') {
      let data = {
        param : 'terminate',
        header: 'Terminate Application',
        content: [
          {
            label: 'Reason for termination',
            reasonsDropdown:[
              'Deceased','Funding Change','Moved out of County','Not Eligible','Services Cancelled by Customer','Update TAF/Reassessment','Eligibility Expired'
            ]
          },
        ],
        actions: ['Terminate', 'Cancel']
      };
      this.openDialog(data, event);
    }
    else if(event?.terminateStatus == 'viewTerminatedReason') {
      // get api call for getting terminated application data
      this.applicantService.fetchTerminatedApplication(event?.applicationId).subscribe({
        next: (data: any) => {
          let terminatedData = {
            param : 'viewTerminatedReason',
            header: 'Termination Details',
            content: [
              {
                'Termination Date': data?.terminationDate,
                'Reason': data?.terminationReason,
                'Comments': data?.terminationComments,
                'Terminated By': data?.terminatedBy,
              },
            ],
            actions: ['Ok']
          }
          this.openDialog(terminatedData, event);
        },
        error: (error) => {
          console.log("There was an error fetching terminated application:", error);
          this.toastr.error('There was an error fetching terminated application. Please try again.');
        }
      });
    }
    else if (event?.workflowStatusId) {
      if(event?.completionStatus == '1') {
        this.sharedCaseManagementService.changeCase(
          {
            "caseId": event.applicationId,
            "caseStatusId": event.workflowStatusId,
          }
        );
        this.sharedCaseManagementService.changeCaseView('view');
        this.router.navigate(['/case-detail'], {
          queryParams: { id: event.applicantId },
          state: { 'caseView': 'view' }
        });
      }
      else {
        localStorage.setItem('caseId', event.applicationId);
        localStorage.setItem('caseView', 'view');
        const currentUrl = window.location.origin + '/eligibility/preview-application-form';
        window.open(currentUrl, '_blank');
      }
    }
    else {
      this.navigateToApplicationForm(event?.applicationId, event?.completionStatus);
    }
  }
  navigateToApplicationForm(applicationId: number,completionStatus: string) {
    this.sharedApplicantService.changeApplicantId(this.applicant.applicantId);
    this.router.navigate(['/application-form'], {
      queryParams: { id: applicationId },
      state: { 'previewForm': !!(completionStatus == '1' || completionStatus == '2' || completionStatus == '3') }
    });
  }

  viewApplicantList() {
    this.router.navigate(['/applicant-list']);
  }

  viewApplicationForm() {
    this.router.navigate(['/application-form']);
  }
  readonly dialog = inject(MatDialog);
  openDialog(data: any, event: any) {
    
    const dialogRef = this.dialog.open(ApplicantDetailDialogComponent,
      {
        data: data,
        width: '40rem',
        height: data.param == 'terminate' ? '35rem' : '25rem'
      }
    );
    dialogRef.afterClosed().subscribe(result => {
      if(result) {
        if(data?.param == 'terminate') {
          // post api call for giving termination reason
          let applicationId = event?.applicationId;
          this.applicantService.terminateApplication(result, applicationId).subscribe({
            next: (data: any)=> {
            if (this.applicantId) {
              this.fetchApplicantDetails(this.applicantId);
              this.fetchApplications(this.applicantId , this.start, this.pageSize);
            }
          },
            error: (error) => {
              console.error('There was an error terminating the application:', error);
              this.toastr.error('There was an error terminating the application. Please try again.');
            }
          });
        }
      }
    });
  }
  onRenewalClicked(element: any) {
    this.isLoading = true;
    this.applicantService.checkForRenewalParentApplication(element.applicationId).subscribe({
      next: (response: any) => {
        console.log(response);
        this.isLoading = false;
        if(!response) {
          this.sharedApplicantService.changeApplicantId(this.applicant.applicantId);
          this.router.navigate(['/application-form'], {
            queryParams: { id: element.applicationId },
          });
          this.userService.setParentApplicationId(element.applicationId);
        }
        if(response?.applicationId) {
          this.toastr.info('Renewal application already exists for this application.', '', { timeOut: 3000 });
          /* this.sharedApplicantService.changeApplicantId(this.applicant.applicantId);
          this.router.navigate(['/application-form'], {
            queryParams: { id: response.applicationId },
          }); */
        }
      },
      error: (error) => {
        this.isLoading = false;
        console.error('Error checking for renewal parent application:', error);
      }
    });
  }
  onPrintRenewalLetter(element: any) {
    if(element) {
      this.applicantService.downloadRecertificationLetter(element.applicationId).subscribe({
        next: (response: Blob) => {
        const fileURL = window.URL.createObjectURL(response);
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = element.applicationId + '-Recertification Letter.docx';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(fileURL);
        this.toastr.success(`Recertification letter download started ...`, '', {
          timeOut: 1000,
        });
        window.location.reload();
      },
        error: (error) => {
          console.error('Error viewing document:', error);
          this.toastr.error('Could not view the document', '', { timeOut: 1000 });
        }
      });
    }
  }
}
